import React from 'react';
import { Activity, Database, Sigma, TrendingDown, TrendingUp } from 'lucide-react';
import { MetricCardData } from '../../services/analytics';

interface MetricCardProps {
  metric: MetricCardData;
}

const MetricCard: React.FC<MetricCardProps> = ({ metric }) => {
  const Icon = pickMetricIcon(metric.label);
  const toneColor = metric.tone === 'positive'
    ? 'var(--status-success)'
    : metric.tone === 'warning'
      ? 'var(--status-warning)'
      : 'var(--text-main)';

  return (
    <div className="premium-card" style={{ padding: '1.2rem', minHeight: '152px', display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
      <span className="icon-tile" aria-hidden="true">
        <Icon size={20} strokeWidth={2.1} />
      </span>
      <div>
        <span className="mono-label" style={{ marginBottom: '0.5rem' }}>{metric.label}</span>
        <strong style={{ display: 'block', color: toneColor, fontSize: '2rem', lineHeight: 1.05, fontWeight: 760 }}>
          {metric.value}
        </strong>
        <p style={{ margin: '0.75rem 0 0', fontSize: '0.875rem', lineHeight: 1.45 }}>{metric.detail}</p>
      </div>
    </div>
  );
};

const pickMetricIcon = (label: string) => {
  if (/rows/i.test(label)) return Database;
  if (/average/i.test(label)) return Sigma;
  if (/previous/i.test(label)) return /-/.test(label) ? TrendingDown : TrendingUp;
  if (/total/i.test(label)) return Activity;
  return TrendingUp;
};

export default MetricCard;
